export const UPDATE_GLOBAL_TAB_INDEX = 'updateGlobalTabIndex'
export const UPDATE_IS_AUTHENTICATED_USER = 'updateIsAuthenticatedUser'
export const UPDATE_SHOW_GLOBAL_LOADER = 'updateShowGlobalLoader'
export const UPDATE_SHOW_TRANSPARENT_GLOBAL_LOADER = 'updateShowTransparentGlobalLoader'
export const UPDATE_CONNECTED_USER = 'updateConnectedUser'

export const UPDATE_PROFILE = 'updateProfile'
